module.exports = __webpack_public_path__ + "static/media/tommi2.8332b047.jpeg";